import '../UI/typography.css';
import styled, { css } from "styled-components";

export const Container = styled.div`
  max-width: 100%;
  margin: 20px auto;
  font-family: var(--ui-font, "Inter UI", "Segoe UI", sans-serif);
  color: #333;
`;

export const DownloadLink = styled.a`
  display: inline-block;
  margin-bottom: 15px;
  color: #007bff;
  cursor: pointer;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }
`;

export const TabsWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
  flex-wrap: wrap;
`;

export const Tab = styled.button`
  padding: 8px 16px;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.25s ease, color 0.25s ease;

  ${({ active }) =>
    active &&
    css`
      background-color: #007bff;
      color: white;
      border-color: #007bff;
    `}

  &:hover:not(:disabled) {
    background-color: #cfe2ff;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  min-width: 600px;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #dee2e6;
    padding: 8px 12px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  thead {
    background-color: #f8f9fa;
  }

  tbody tr:nth-child(odd) {
    background-color: #fefefe;
  }

  tbody tr:nth-child(even) {
    background-color: #f7f9fc;
  }

  tbody tr:hover {
    background-color: #e1e9ff;
  }
`;

export const Th = styled.th`
  text-align: left;
  font-weight: 700;
  white-space: nowrap;
`;

export const Tr = styled.tr`
  background-color: ${({ index }) => (index % 2 === 0 ? "#fefefe" : "#f7f9fc")};
`;

export const Td = styled.td`
  text-align: left;
  vertical-align: middle;
  white-space: pre-wrap;
  word-break: break-word;
`;
